var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9966 14.309L27 26.9795H14.3287L14.3355 23.2982L18.8261 18.8078L23.3184 14.3158L26.9966 14.3107V14.309ZM3.68159 12.6842L8.17391 8.19216L12.6645 3.70183L12.6713 0.0221879H0L0.00341435 12.6893L3.68159 12.6842ZM0.0256037 18.0108L4.51792 22.5028L9.00854 26.9932L12.6884 27V14.3295L0.0204835 14.3329L0.0256037 18.0108ZM26.9744 8.98919L22.4821 4.49716L17.9915 0.00682565L14.3116 0V12.6705L26.9795 12.6671L26.9744 8.98919ZM0.838043 26.9795V25.4588H1.38593V25.2728H0.0836345V25.4588H0.631521V26.9795H0.836338H0.838043ZM1.72388 26.9795V25.4076H1.75801L2.20861 26.9795H2.56192L3.01252 25.4076H3.04665V26.9795H3.24464V25.2728H2.85378L2.39977 26.8498H2.36734L1.91333 25.2728H1.52248V26.9795H1.72046H1.72388Z",
    fill: "#322D8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e14c05e1fb0f10980fc826b261abffad.svg";
export { ForwardRef as ReactComponent };